import { render, staticRenderFns } from "./upLoadAd.vue?vue&type=template&id=48518ac6&scoped=true&"
import script from "./upLoadAd.vue?vue&type=script&lang=js&"
export * from "./upLoadAd.vue?vue&type=script&lang=js&"
import style0 from "./upLoadAd.vue?vue&type=style&index=0&id=48518ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48518ac6",
  null
  
)

export default component.exports